import React from 'react';

import {Empty} from '../common/Empty';
import {EMPTY_PROPS_THREADS} from '../common/EmptyContent';

type ThreadsTableNoRowsOverlayProps = {
  threadsLoading: boolean;
  threadsResult: any[];
};

export const ThreadsTableNoRowsOverlay: React.FC<
  ThreadsTableNoRowsOverlayProps
> = ({threadsLoading, threadsResult}) => {
  if (threadsLoading) {
    return null;
  }

  const isEmpty = threadsResult.length === 0;
  if (!isEmpty) {
    return null;
  }

  return <Empty {...EMPTY_PROPS_THREADS} />;
};
